/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, type PropsWithChildren } from 'react'

import { useSubscriptionState, type SubscriptionState } from '@/api/hooks/useSubscriptionState'
import { useIndividuals } from '@/hooks/useIndividuals'

const SubscriptionContext = createContext<SubscriptionState | undefined>(undefined)

/**
 * Holds the single subscription subscription for the whole authenticated app. Mounted
 * in the `_authenticated` layout alongside RegenProvider so the RTDB listener stays
 * alive on every page — an admin flipping a state while the user sits on /documents
 * still locks the UI without a reload.
 */
export const SubscriptionProvider = ({ children }: PropsWithChildren) => {
  const { selectedIndividual } = useIndividuals()
  const subscription = useSubscriptionState(selectedIndividual)

  return (
    <SubscriptionContext.Provider value={subscription}>{children}</SubscriptionContext.Provider>
  )
}

export function useSubscription() {
  const context = useContext(SubscriptionContext)

  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider')
  }

  return context
}
